<template>
    <div>
      <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">
          {{ $t("account-page-payment.connection_title") }}
        </h6>
      </div>
      <div class="card-body">
        <div class="col-lg-12" v-if="success">
          <div class="alert alert-success">
            {{ $t("account-page-payment.connection_success") }}
          </div>
        </div>

        <div class="col-lg-12">
            <p>{{ $t("account-page-payment.connection_description") }}</p>
        </div>
        
        <form class="p-4">
          <div class="form-group row" v-for="(connection, index) in connectionSetting.connections" :key="index">
              <label class="col-sm-2 col-form-label">
                {{ $t("account-page-payment.connection_data_label", { index: index + 1 }) }}
              </label>
              <div class="col-sm-6">
                  <input type="text" class="form-control" v-model="connection[`connection_data0${index + 1}`]"/>
              </div>
          </div>
  
          <div class="row">
            <div class="col-lg-12" align="center">
              <router-link
                class="btn btn-danger ml-3"
                type="button"
                :to="{ name: 'checkin-facility-dashboard-home' }"
              >
                {{ $t("account-page-payment.payment_option_back_btn") }}
              </router-link>         
              <button
                @click="$bvModal.show('modal-confirmation')"
                type="button"
                class="btn btn-primary ml-3"
              >
                {{ $t("account-page-payment.payment_option_confirm_btn") }}
              </button>
            </div>
          </div>
        </form>
      </div>
  
      <confirmation-modal-component @click-handler="submit" />
    </div>
  </template>
  
  <script>
//   import currencies from "currency-codes/data";
  import ConfirmationModalComponent from "./confirmation-modal.component.vue";
  
  export default {
    name: "Connection",
    components: {
      ConfirmationModalComponent,
    },
    props: {
      facility: {
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        success: false,
        connectionSetting: {
            connections: [],
            facility_id: window._app_facility.id
        }
      };
    },
    async mounted() {
      await this.fetchPaymentGatewaySettings();
    },
    methods: {
      async submit() {
        
          const response = await this.$lionheart.put(
            '/v2/facility-settings/update-facility-connection-settings',
            this.connectionSetting
          );
          if (response.data.success) {
            this.success = true;
            setTimeout(() => {
              this.success = false;
            }, 5000);
          }
      },
      async fetchPaymentGatewaySettings() {
          const response = await this.$lionheart.get(
            '/v2/facility-settings/facility-connection-settings',
            { params: { facility_id: this.facility.id } }
          );

          if (Object.keys(response.data.data).length > 0) {
            this.connectionSetting.connections = response.data.data.connections;
          }
      },

    },
  };
  </script>
  
  <style>
  </style>